<script>
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import flashMessage from "../../components/flashMessahe";
import VueSweetalert2 from "vue-sweetalert2";
import ErrorMessage from "../../components/error-message";
import { ModelSelect } from 'vue-search-select';

import {
  required,
  email,
  minLength,
  sameAs,
  maxLength,
  minValue,
  maxValue,
  numeric,
  url,
  alphaNum,
} from "vuelidate/lib/validators";

export default {
  components: {
      ErrorMessage,
    Layout,
    PageHeader,
    flashMessage,
      ModelSelect,
  },
  data() {
    return {
      errorMessage: "",
      title: "Sales Manager Create",
      items: [
        {
          text: "Sales Manager",
          href: "/",
        },
        {
          text: "Create",
          active: true,
        },
      ],
      status: "not_accepted",
      checkCustom: "not_accepted",
      checked: true,
      errors: null,
      agents: [],
      admins: [],
        visible:false,
        message:"",
      form: {
        manager_user_id: "",
        customer_user_id: "",
      },
      submitform: false,
      submitted: false,
    };
  },
  validations: {
    form: {
      manager_user_id: {
        required,
      },
      customer_user_id: {
        required,
      },
    },
  },
  mounted() {
    this.getAgentList();
    this.getAdminList();
  },
  methods: {
      onClose(){
          this.visible=false;
      },
      async getAgentList() {
          try {
              axios
                  .get("/api/user/approved/list", {
                      params: {
                          accessToken: localStorage.getItem("access_tocken"),
                      },
                  })
                  .then((response) => {
                      if (response.data.status) {
                          let temp=response.data.data;
                          let i;
                          let arr=[];
                          for (i=0;i<temp.length;i++){
                              if(temp[i].account_type=='b2b' && temp[i].approved_agents[0]!=undefined){
                                  if(temp[i].approved_agents[0].approval_status=='approved') {
                                      temp[i].value = temp[i].id;
                                      temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                                      arr.push(temp[i]);
                                  }
                              }
                          }
                          this.agents = arr;
                      } else {
                          var str = response.data.message;
                          var jsonParse = JSON.parse(str);
                          this.errorCheck(jsonParse);
                      }
                  })
                  .catch((error) => {
                      console.log(error.message);
                  });
          } catch (err) {
              console.log(err);
          }
      },
    async getAdminList() {
      try {
        axios
          .get("/api/admin/list", {
            params: {
              accessToken: localStorage.getItem("access_tocken"),
            },
          })
          .then((response) => {
            if (response.data.status) {
                let temp=response.data.data;
                let i;
                let arr=[];
                for (i=0;i<temp.length;i++){
                    if(temp[i].account_type=='admin'){
                            temp[i].value = temp[i].id;
                            temp[i].text = temp[i].first_name + ' ' + temp[i].last_name + ' (' + temp[i].username + ')';
                            arr.push(temp[i]);
                        }

                }
              this.admins = arr;
            } else {
              var str = response.data.message;
              var jsonParse = JSON.parse(str);
              this.errorCheck(jsonParse);
            }
          })
          .catch((error) => {
            console.log(error.message);
          });
      } catch (err) {
        console.log(err);
      }
    },
    formSubmit(event) {
      this.submitted = true;
      this.$v.$touch();
      axios
        .post("/api/sales_manager/create", {
          manager_user_id: this.form.manager_user_id,
          customer_user_id: this.form.customer_user_id,
          created_by: localStorage.getItem("uuid"),
          updated_by: localStorage.getItem("uuid"),
          accessToken: localStorage.getItem("access_tocken"),
        })
        .then((response) => {
          if (response.data.status) {
            this.$refs.salemanaegrform.reset();
              if(this.visible){
                  this.visible=false;
              }
              this.$swal("Good job!", "Sales Manaegr Created", "success");
            this.$router.push({ name: "sales_manager_list" });
          } else {
            var str = response.data.message;
            var jsonParse = JSON.parse(str);
            this.errorCheck(jsonParse);
          }
        })
        .catch((error) => {
          if (error.response != undefined) {
            this.errors = error.response.data.errors;
          }
        });
    },
    errorCheck(obj) {
        if(obj.statusCode == 403){
            this.visible=true;
            this.message="Access Permission Denied";
            this.errors = obj.message;
        }else if(obj.message=='User Already Assigned'){
            this.visible=true;
            this.message="This customer ID has already been assigned";
            this.errors = "Sorry";
        }
        else if (obj.error) {
        this.errors = obj.message;
      } else if (obj.message == "Token has expired") {
          this.$swal.fire({
              title: 'LogOut!',
              text: 'Token Has Expired',
              icon: 'error',
              toast:'true',
              position: 'top-end',
          });
        this.$router.push({ name: "logout" });
      } else if (
        obj.message !== "Token has expired" &&
        obj.message !== "The given data was invalid."
      ) {
        this.errors = obj.message;
      } else if (obj.message == "The given data was invalid.") {
        this.errors = obj.errors;
      } else {
        this.flashMessage.show({
          time: 5000,
          status: "error",
          title: "Error",
          message: "Problem in data save",
        });
      }
    },
    resetForm(event) {
      console.log("Reseting the form");
      event.target.reset();
    },
  },
};
</script>

<template>
  <Layout>
    <flashMessage/>
    <PageHeader :title="title" :items="items" />
      <ErrorMessage :visible="visible" :errors="errors" v-on:close="onClose" :message="message"/>
    <div class="row">
      <div class="col-lg-12 col-sm-12">
        <div class="card">
          <div class="card-body">
<!--            <div v-if="errors && !visible" class="font-bold mb-4 ">-->
<!--              <div v-for="(v, k) in errors" :key="k">-->
<!--                <p v-for="error in v" :key="error" class="text-sm">-->
<!--                  {{ error }}-->
<!--                </p>-->
<!--              </div>-->
<!--            </div>-->
            <b-form class="needs-validation" ref="salemanaegrform" @submit.prevent="formSubmit">
              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="manager_user_id">Select Manager</label>
                      <model-select :options="admins"
                                    v-model="form.manager_user_id"
                                    :class="{ 'is-invalid': submitted && $v.form.manager_user_id.$error}"
                                    placeholder="Select Admin">
                      </model-select>
                    <div
                      v-if="submitted && $v.form.manager_user_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.manager_user_id.required">This value is required.</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label class="required" for="customer_user_id">Select Customer</label>
                      <model-select :options="agents"
                                    v-model="form.customer_user_id"
                                    :class="{ 'is-invalid': submitted && $v.form.customer_user_id.$error}"
                                    placeholder="Select user">
                      </model-select>
                    <div
                      v-if="submitted && $v.form.customer_user_id.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.form.customer_user_id.required">This value is required.</span>
                    </div>
                  </div>
                </div>
              </div>
              <button class="btn btn-primary" type="submit">Submit</button>
                <div class="col-md-12 height-300px">

                </div>
            </b-form>
          </div>
        </div>
        <!-- end card -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>
<style>
.height-300px{
    height: 200px;
}
</style>
